export function slicePage<T>(A: T[], pageSize: number, pageNumber: number): T[] {
  return A.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
}
